// @flow
import {useQuery, queryOptions} from '@tanstack/react-query';
import type {UseQueryReturn} from '@tanstack/react-query';
import {documentationOrgServiceTypesList} from 'api/v2';
import type {UISessionServiceType} from '../model/types';
import {sessionDocumentKeys} from './keys';
import {toUIServiceTypes} from './adapter';

// Raw options (no `select`) so both the hook and imperative `fetchQuery` callers
// share one cache entry. Org scope comes from the X-Org-ID header. Service types
// rarely change, so cache for an hour to avoid refetching on every list refresh.
export const orgServiceTypesQueryOptions = (): {[string]: mixed} =>
  queryOptions({
    queryKey: sessionDocumentKeys.orgServiceTypes,
    queryFn: () => documentationOrgServiceTypesList(),
    staleTime: 60 * 60 * 1000,
  });

// Fetches the org's enabled service types for the multi-select / filters.
export const useOrgServiceTypes = ({
  enabled = true,
}: {enabled?: boolean} = {}): UseQueryReturn<
  Array<UISessionServiceType>,
  any,
> =>
  useQuery({
    ...orgServiceTypesQueryOptions(),
    enabled,
    select: (response) => toUIServiceTypes(response.data.results),
  });
